import { createContent, ordinalIndicator } from '@altify/utils';

export const content = createContent({
  en: {
    buyMonthDate: {
      buyOn: 'Buy on the',
      eachMonth: 'of each Month',
    },
    buyWeekDate: {
      buyOn: 'Buy on',
      eachWeek: 'of each week',
    },
    unavailableDates: 'Dates from the 29th - 31st are unavailable',
    date: (monthDaySelection: number) => {
      return `${monthDaySelection}${ordinalIndicator?.(monthDaySelection)}`;
    },
  },
  de: {
    buyMonthDate: {
      buyOn: 'Kauf am',
      eachMonth: 'eines jeden Monats',
    },
    buyWeekDate: {
      buyOn: 'Kauf am',
      eachWeek: 'jede Woche',
    },
    unavailableDates: 'Die Tage vom 29. bis 31. sind nicht verfügbar.',
    date: (monthDaySelection: number) => {
      return `${monthDaySelection}.`;
    },
  },
});
